import { Permissao } from 'pages/@types';
import { useSelector } from 'react-redux';
import { Role } from 'utils/variables';

export function usePermit(roles: string[], permissions: string[]) {
  const { profile } = useSelector((state: any) => state.usuario);

  if (!profile) return false;

  return (
    profile.role === Role.ADMIN ||
    roles.some(r => r === profile.role) ||
    (profile.permissoes &&
      permissions.some(permission =>
        profile.permissoes.some((p: Permissao) => p.nome === permission),
      ))
  );
}
